<template>
    <div class="business-pay-success" v-if="orderCode != null">
        <div class="business-pay-success-icon">
            <van-icon name="success" size="100" color="#25C973"/>
            <div style="color:#25C973">支付成功</div>
        </div>
        <div class="business-pay-success-text" v-if='orderType == 1'>
            <div style="text-align: left">您的订单已成功受理！</div>
            <div style="text-align: left">
                订单号为{{orderCode}}，您所申请的手机卡将在2个工作日内通过中通快递邮寄，请您注意查收！收到手机卡后请您关注微信公众号“民生通讯官微”进行号码激活和后续充值缴费。如有疑问请拨打客服电话400-6509-170
            </div>
        </div>
        <div class="business-pay-success-text" v-else>
            <div style="text-align: left">您的订单已成功受理！</div>
            <div style="text-align: left">
                订单号为{{orderCode}}！您所申请的产品将在11月1日后通过中通快递陆续发货，请您注意查收！收到产品后请您搜索微信公众号“在家看看”进行关注。如有疑问请拨打客服电话400-6509-170
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: 'activeBusinessPaySuccess',
        data() {
            return {
                orderType: '1',
                orderCode: null
            }
        },
        created() {
            this.orderCode = this.$route.query.od;
            if (this.orderCode == null || this.orderCode == '') {
                this.$dialog.alert({
                    message: '支付信息获取失败!'
                }).then(() => {
                    //关闭窗口
                });
                return;
            }
            if (this.orderCode.indexOf('KANKAN') != '-1') {
                this.orderType = '2';
            }

        },
        methods: {}
    }
</script>

<style lang="less">
    @main-blue: #20A0FF;
    @main-white: #ffffff;

    .business-pay-success {
        height: 100%;
        padding: 10px;
        border-radius: 50px;
        margin-top: 20px;
        &-icon {
            text-align: center;
            height: 100px;
        }
        &-text {
            text-indent: 2em;
            margin-top: 50px;
            font-size: 15px;
            color: rgb(111, 112, 112);
            padding: 20px;
            margin-bottom: 10px;
        }
    }


</style>
